angular.module('bmsApp.reports')
	.controller('AnnualRevenueComparisonCtrl', AnnualRevenueComparisonCtrl);

AnnualRevenueComparisonCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
];

function AnnualRevenueComparisonCtrl($scope, $state, $q) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
	});

	this.$onInit = () => {

	};

	$scope.$watch(function () {
		return $scope.ReportIndex.selectedReport.reportData;
	}, function (value) {
		if (angular.isObject(value)) {
			setData();
		}
	});

	function setData() {
		let data = $scope.ReportIndex.selectedReport.reportData;
		self.categories = data.categories;
		// self.series = data.series;

		self.series = [];
		self.series.push({
			type: 'spline',
			name: data.selectedYear,
			data: data.series,
			color: 'gray',
			lineWidth: 4,
			marker: {
				lineWidth: 3,
				lineColor: 'orange',
				fillColor: 'white'
			}
		});

		if (angular.isObject(data.previous)) {
			angular.forEach(data.previous, (series, year) => {
				self.series.push({
					type: 'spline',
					name: year,
					data: series,
					// color: 'gray',
					lineWidth: 4,
					// marker: {
					// 	lineWidth: 3,
					// 	lineColor: 'orange',
					// 	fillColor: 'white'
					// }
				});
			});
		}

		self.series.reverse();
		self.series.unshift(self.series[self.series.length -1]);
		self.series.pop();


		setChart();
		self.loading = false;
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.submitClick = function () {

	};


	function setChart() {
		self.chart = {
			revenue: {
				title: {
					text: 'Revenue Comparison'
				},
				subtitle: {
					text: '',
					style: {
						color: '#AAA'
					}
				},
				credits: false,
				xAxis: [
					{
						categories: self.categories,
					}
				],
				yAxis: [
					{
						labels: {
							format: '£{value}'
						},
						title: {
							text: 'Revenue'
						}
					}
				],
				tooltip: {
					valuePrefix: '£'
				},
				series: self.series,
			}
		};
		self.chartObjs = {};
	}
}